import { Link } from 'react-router-dom'

export default function Offline() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        background: 'var(--bg-primary, #F7FAF7)',
        color: 'var(--text-primary, #1A202C)',
      }}
    >
      <svg
        width="64"
        height="64"
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--forest-green, #1B5E20)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginBottom: '1.5rem' }}
      >
        <line x1="1" y1="1" x2="23" y2="23" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 0.5rem' }}>You're offline</h1>
      <p style={{ maxWidth: '400px', color: 'var(--slate, #4A5568)', margin: '0 0 1.5rem' }}>
        It looks like your connection dropped. Some pages may still work if they've been visited before.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          background: 'var(--forest-green, #1B5E20)',
          color: '#fff',
          textDecoration: 'none',
          fontWeight: 600,
        }}
      >
        Try going home
      </Link>
    </div>
  )
}
